import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { BranchEndpointService } from '../_services/branch-endpoint.service';
import { BranchDetails } from '../_types/api.types';

export const branchDataResolver: ResolveFn<BranchDetails | null> = () => {
  const branchService = inject(BranchEndpointService);

  return branchService.load();
};
